module.exports = __webpack_public_path__ + "img/plat_4871.23fe2b4c.jpg";